import { Form as FormikForm, FormikFormProps } from 'formik'
import React, { FC } from 'react'

// @ts-expect-error - TODO: remove formik in its entirety
export const Form: FC<FormikFormProps> = props => <FormikForm noValidate {...props} />
